import {forwardRef, HTMLAttributes} from 'react';

import base from './16px';
import large from './24px';
import {IconSize, IconType} from './types';

export type IconProps = {
    icon: IconType;
    size?: IconSize;
} & HTMLAttributes<HTMLDivElement>;

const Icon = forwardRef<HTMLDivElement, IconProps>(
    ({className, icon, size = 'lg', ...rest}, ref) => {
        const SVG = size === 'lg' ? large[icon] : base[icon];

        return (
            <div className={className} ref={ref} {...rest}>
                <SVG data-icon={icon} />
            </div>
        );
    },
);

Icon.displayName = 'Icon';

export default Icon;
